export default {
  root: ({ props }) => ({
    class: [
      'inline-flex relative',
      {
        'opacity-60 select-none pointer-events-none cursor-default': props.disabled
      }
    ]
  }),
  panel: {
    class: [
      // Spacing
      'p-5',

      // Shape
      'border-0 dark:border',
      'shadow-md rounded-md',

      // Colors
      'bg-secondary-0 dark:bg-secondary-900',
      'text-secondary-700 dark:text-white/80',
      'dark:border-secondary-700'
    ]
  },
  meter: {
    class: [
      // Position and Overflow
      'overflow-hidden',
      'relative',

      // Shape and Size
      'border-0',
      'h-3',

      // Spacing
      'mb-2',

      // Colors
      'bg-secondary-100 dark:bg-secondary-700'
    ]
  },
  meterlabel: ({ instance }) => ({
    class: [
      // Size
      'h-full',

      // Colors
      {
        'bg-danger-500 dark:bg-danger-400/50': instance?.meter?.strength == 'weak',
        'bg-warning-500 dark:bg-warning-400/50': instance?.meter?.strength == 'medium',
        'bg-green-500 dark:bg-green-400/50': instance?.meter?.strength == 'strong'
      },

      // Transitions
      'transition-all duration-1000 ease-in-out'
    ]
  }),
  showicon: {
    class: ['absolute top-1/2 right-3 -mt-2', 'text-secondary-600 dark:text-white/70']
  },
  hideicon: {
    class: ['absolute top-1/2 right-3 -mt-2', 'text-secondary-600 dark:text-white/70']
  },
  transition: {
    enterFromClass: 'opacity-0 scale-y-[0.8]',
    enterActiveClass: 'transition-[transform,opacity] duration-[120ms] ease-[cubic-bezier(0,0,0.2,1)]',
    leaveActiveClass: 'transition-opacity duration-100 ease-linear',
    leaveToClass: 'opacity-0'
  }
};
